import { Grid, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';

import VCERNButton from '../../common/elements/VCERNButton';

import VCERNTypography from '../../common/elements/VCERNTypography';

import { connect } from 'react-redux';
import icons from '../../common/icons';
import VCERNTextField from '../../common/elements/VCERNTextField';
import { useState } from 'react';
import AC from '../../redux/actions/actionCreater';
import VCERNAlert from '../../common/elements/VCERNAlert';
import DashboardHeader from '../../common/DashboardHeader';

const useStyles = makeStyles(theme => ({
    input: { margin: '5px 0' },
    title: { margin: '15px 0', fontWeight: 'bold' },
    button: { margin: '20px 0' },
}));

function ManageGroups({ triggerEvent, triggerNotification, token, selectedPool, setCurrentPageTitle, triggerMail, triggerSMS }) {
    const classes = useStyles();

    const [data, setData] = useState({
        description: '',
        member_id: '',
        place_death: '',
        cause_death: '',
        mail_message: '',
        mail_subject: '',
        sms_message: '',
    });
    const [successMessage, setSuccessMessage] = useState('');

    const { description, member_id, place_death, cause_death, mail_message, mail_subject, sms_message } = data;

    useEffect(() => {
        setCurrentPageTitle(`Manage Groups`);

        // eslint-disable-next-line
    }, []);

    const handleOnChange = evt => {
        const { value, name } = evt.target;
        setData({ ...data, [name]: value });
    };

    const handleTriggerNotification = () => {
        triggerNotification({ title: 'Announcement', description }, token, () => {
            setSuccessMessage('Notification Sent Successfully.');
            setData({ ...data, description: '' });
        });
    };
    const handleTriggerSMS = () => {
        triggerSMS({ message: sms_message }, token, () => {
            setSuccessMessage('Message Sent Successfully.');
            setData({ ...data, sms_message: '' });
        });
    };
    const handleTriggerMail = () => {
        triggerMail({ message: mail_message, subject: mail_subject }, token, () => {
            setSuccessMessage('Mail Sent Successfully.');
            setData({ ...data, mail_message: '', mail_subject: '' });
        });
    };
    const handleTriggerEvent = () => {
        triggerEvent(
            {
                member_id,
                pool_id: selectedPool?._id,
                title: cause_death,
                description: place_death,
            },
            token,
            () => {
                setSuccessMessage('Notification Sent Successfully.');
                setData({ ...data, member_id: '', place_death: '', cause_death: '' });
            },
        );
    };

    const disableEventTriggerButton = !place_death || !cause_death || !member_id;

    return (
        <Grid container spacing={3}>
            <DashboardHeader />
            <Grid item xs={12}>
                <VCERNTypography className={classes.title} variant="h5" value={`Trigger ${selectedPool.default ? 'Death' : ''} Announcement & Contribution Collection `} />
                <VCERNTextField variant="outlined" className={classes.input} placeholder="Membership ID" value={member_id} name="member_id" onChange={handleOnChange} />
                <VCERNTextField variant="outlined" className={classes.input} placeholder="Place of Death " value={place_death} name="place_death" onChange={handleOnChange} />
                <VCERNTextField variant="outlined" className={classes.input} placeholder="Cause of Death " value={cause_death} name="cause_death" onChange={handleOnChange} />
                <VCERNButton fullWidth startIcon={icons.trigger} value="Trigger" disabled={disableEventTriggerButton} className={classes.button} onClick={handleTriggerEvent} />

                <VCERNTypography className={classes.title} variant="h5" value="Notification" />
                <VCERNTextField
                    rows={5}
                    multiline
                    variant="outlined"
                    className={classes.input}
                    placeholder="Blast notification to all members..."
                    value={description}
                    name="description"
                    onChange={handleOnChange}
                />
                <VCERNButton fullWidth startIcon={icons.trigger} value="Trigger Notify" disabled={!description} className={classes.button} onClick={handleTriggerNotification} />

                <VCERNTypography className={classes.title} variant="h5" value="Mail" />

                <VCERNTextField variant="outlined" className={classes.input} placeholder="Subject" value={mail_subject} name="mail_subject" onChange={handleOnChange} />
                <VCERNTextField
                    rows={5}
                    multiline
                    variant="outlined"
                    className={classes.input}
                    placeholder="Blast mail to all members..."
                    value={mail_message}
                    name="mail_message"
                    onChange={handleOnChange}
                />
                <VCERNButton
                    fullWidth
                    startIcon={icons.trigger}
                    value="Trigger Mail"
                    disabled={!mail_message || !mail_subject}
                    className={classes.button}
                    onClick={handleTriggerMail}
                />

                <VCERNTypography className={classes.title} variant="h5" value="Message" />
                <VCERNTextField
                    rows={5}
                    multiline
                    variant="outlined"
                    className={classes.input}
                    placeholder="Blast message to all members..."
                    value={sms_message}
                    name="sms_message"
                    onChange={handleOnChange}
                />
                <VCERNButton fullWidth startIcon={icons.trigger} value="Trigger Message" disabled={!sms_message} className={classes.button} onClick={handleTriggerSMS} />
            </Grid>

            <VCERNAlert message={successMessage} onClose={() => setSuccessMessage(false)} success={true} />
        </Grid>
    );
}
export default connect(state => state, {
    triggerNotification: AC.triggerNotification,
    triggerEvent: AC.triggerEvent,
    triggerMail: AC.triggerMail,
    triggerSMS: AC.triggerSMS,
    setCurrentPageTitle: AC.setCurrentPageTitle,
})(ManageGroups);
